import React, { useEffect, useMemo, useState } from "react";
import DataTable from "../../../../components/data-table";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
    },
];

export default function FormAnswerUserPage(props) {

    const { form, data } = props;

    const [dataOfTable, setDataOfTable] = useState([]);
    const headerCells = useMemo(
        () => [
            {
                field: "order",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "question",
                title: "سوال",
                mainField: false,
            },
            {
                field: "answer",
                title: "پاسخ",
            },
        ],
        []
    );

    const handelAnswers = () => {
        let validData = [];
        form.sections.sort((a, b) => a.sort - b.sort).forEach(sec => {
            sec.questions.sort((a, b) => a.order - b.order).forEach(ques => {
                validData.push({
                    order: validData.length + 1,
                    question: ques.title,
                    answer: data.answers.find(item => item.questionId === ques.id)?.answer || ""
                })
            })
        })

        setDataOfTable(validData)
    }

    useEffect(() => {
        handelAnswers();
    }, []);

    return (
        <div className="p-3">
            <DataTable
            orderBy="DESC"
                headCells={headerCells}
                data={dataOfTable}
                title={`پاسخ های "${data.uniqueId}" به فرم "${form.title}"`}
            />
        </div>
    );
}
